import React from 'react'
import styled from '@emotion/styled'
import { FlexRowDiv } from '../generic/Basics'

export default () => (
  <HeaderDiv id={'globalHeader'}>
    <FlexRowDiv>
      <StyledImg src={__PATH_PREFIX__ + '/KBBLogoSeal.png'} alt="Kelley Blue Book" />
      <img src={__PATH_PREFIX__ + '/KBBLogoTypeLockup.svg'} width="215" alt="Kelley Blue Book" />
    </FlexRowDiv>
  </HeaderDiv>
)

const StyledImg = styled.img`
  height: 81px;
  align-self: flex-start;
  margin-right: 8px;
  margin-top: -3px;
  position: relative;
`

const HeaderDiv = styled.div`
  background-color: #1f3e74;
  display: flex;
  height: 64px;
  justify-content: center;
  left: 0;
  width: 100%;
`
